import { useState } from "react";
import { CheckBox, ProfileFilterRow, ProfileFilterWrapper, ProfilePriceFilter, Styled } from "./ProfileFilter.styled";

export const ProfileFilter = () => {
  const [saleType, setSaleType] = useState("Аll Types");
  const [priceFrom, setPriceFrom] = useState("");
  const [priceTo, setPriceTo] = useState("");
  return (
    <ProfileFilterWrapper>
      <ProfileFilterRow>
        <h5>Filters</h5>
      </ProfileFilterRow>
      <ProfileFilterRow>
        <h5>Sаle Type</h5>
        <CheckBox onClick={() => setSaleType("All")}>
          <input type='checkbox' checked={saleType === "All"} />
          <label>Аll Types</label>
        </CheckBox>
        <CheckBox onClick={() => setSaleType("On Sаle")}>
          <input type='checkbox' checked={saleType === "On Sаle"} />
          <label>On Sаle</label>
        </CheckBox>
        <CheckBox onClick={() => setSaleType("Not For Sаle")}>
          <input type='checkbox' checked={saleType === "Not For Sаle"} />
          <label>Not For Sаle</label>
        </CheckBox>
      </ProfileFilterRow>
      <ProfileFilterRow>
        <h5>Price</h5>
        <ProfilePriceFilter>
          <input placeholder='From' onChange={(e) => setPriceFrom(e.target.value)} value={priceFrom} />
          <input placeholder='To' onChange={(e) => setPriceTo(e.target.value)} value={priceTo} />
          <button disabled={priceFrom.length < 1 && priceTo.length < 1}>Apply</button>
        </ProfilePriceFilter>
      </ProfileFilterRow>
    </ProfileFilterWrapper>
  );
};
